import { IEnhancedStore } from "@montana/models/dev";
import { Action } from "redux";
import {ILocation} from '@montana/shared/map';
// eslint-disable-next-line no-undef
import LatLngBoundsLiteral = google.maps.LatLngBoundsLiteral;
import {IMarket} from '@montana/models/generated/cms.interface';

export enum StoresAction {
    GET_STORES = "@@stores/GET_STORES",
    GET_STORES_IN_MAP = "@@stores/GET_STORES_IN_MAP",
    GET_STORES_FROM_SEARCH = "@@stores/GET_STORES_FROM_SEARCH",
    SET_STORES = "@@stores/SET_STORES",
    GET_USER_LOCATION = "@@stores/GET_USER_LOCATION",
    SET_USER_LOCATION = "@@stores/SET_USER_LOCATION",
    AWAITING = "@@stores/AWAITING",
    COMPLETED = "@@stores/COMPLETED",
    NO_STORES_FOUND = "@@stores/NO_STORES_FOUND"
}

export type IStoresAction = IGetStoresAction
    | IGetStoresInMapAction
    | IGetStoresFromSearch
    | ISetStoresAction
    | IGetUserLocationAction
    | IAwaitingAction
    | ICompletedAction
    | ISetUserLocation
    | INoStoresFound;

export interface IGetStoresAction extends Action<StoresAction.GET_STORES> {
    markets: IMarket[];
}

export interface IGetStoresInMapAction extends Action<StoresAction.GET_STORES_IN_MAP> {
    worldCorners: LatLngBoundsLiteral;
}

export interface IGetStoresFromSearch extends Action<StoresAction.GET_STORES_FROM_SEARCH> {
    query: string;
    language: string;
}

export interface ISetStoresAction extends Action<StoresAction.SET_STORES> {
    stores: IEnhancedStore[];
}
export type IGetUserLocationAction = Action<StoresAction.GET_USER_LOCATION>;
export type IAwaitingAction = Action<StoresAction.AWAITING>;
export type ICompletedAction = Action<StoresAction.COMPLETED>;

export interface INoStoresFound extends Action<StoresAction.NO_STORES_FOUND> {
    noStoresFound: boolean;
}

export interface ISetUserLocation extends Action<StoresAction.SET_USER_LOCATION> {
    userLocation?: ILocation;
}

export const getStores = (markets: IMarket[]): IGetStoresAction => ({ type: StoresAction.GET_STORES, markets });
export const getStoresInMap = (worldCorners: LatLngBoundsLiteral): IGetStoresInMapAction => ({
    type: StoresAction.GET_STORES_IN_MAP,
    worldCorners
});
export const getStoresFromSearch = (query: string, language: string): IGetStoresFromSearch => ({
    type: StoresAction.GET_STORES_FROM_SEARCH,
    query,
    language
});
export const setStores = (stores: IEnhancedStore[]): ISetStoresAction => ({ type: StoresAction.SET_STORES, stores });
export const getUserLocation = (): IGetUserLocationAction => ({ type: StoresAction.GET_USER_LOCATION });
export const awaiting = (): IAwaitingAction => ({ type: StoresAction.AWAITING });
export const completed = (): ICompletedAction => ({ type: StoresAction.COMPLETED });
export const setUserLocation = (userLocation: ILocation): ISetUserLocation => ({
    type: StoresAction.SET_USER_LOCATION, userLocation
})

export const noStoresFound = (noStoresFound: boolean): INoStoresFound => ({
    type: StoresAction.NO_STORES_FOUND,
    noStoresFound
});
